const getTotalValue = (arr) => {
  const result = arr.reduce((acc, obj) => {
    return acc + Number(obj.rateValue);
  }, 0);
  return result;
};

export { getTotalValue };
